import { CLASS_ANCHORED } from 'components/UI/SpeedDial/BaseSpeedDial';

export const JOB_CATEGORY_TYPE_OPTIONS = [
	'Primary Category',
	'Enhancement Category',
];
export const DEFAULT_LIST_ITEM = { id: -1, label: 'No results' };

export const JOB_CATEGORY_KEYS = {
	ID: 'jobCategoryID',
	NAME: 'name',
	DESCRIPTION: 'description',
	TYPE: 'type',
	APP_ID: 'appID',
	OWNING_APPLICATION: 'owningApplication',
	TEMPLATE_ID: 'templateID',
	TEMPLATE_NAME: 'templateName',
	SUBTEMPLATE_IDS: 'subtemplateIDs',
	SUBTEMPLATE_NAMES: 'subtemplateNames',
	IS_PROVIDER: 'isProvider',
	SER: 'SER',
	SER_BLUEPRINT_ID: 'SERBlueprintID',
	TRAINING_TRACK1: 'trainingTrack1',
	TRAINING_TRACK2: 'trainingTrack2',
	TRAINING_TRACK3: 'trainingTrack3',
	TRAINING_TRACK4: 'trainingTrack4',
	TRAINING_TRACK5: 'trainingTrack5',
	TRAINING_TRACK6: 'trainingTrack6',
	TRAINING_TRACK7: 'trainingTrack7',
	TRAINING_TRACK8: 'trainingTrack8',
	DAY_IN_THE_LIFE_ACTIVITY_PRE: 'dayInTheLifeActivityPreLive',
	DAY_IN_THE_LIFE_ACTIVITY_POST: 'dayInTheLifeActivityPostLive',
	NOTE: 'note',
	ACTIVE: 'active',
};

export const TRAINING_TRACK_KEYS = {
	ACTIVE: 'active',
	ID: 'trainingTrackID',
	NAME: 'name',
};

export const JOB_CATEGORY_MAPPING_KEYS = {
	DEPARTMENT: 'department',
	JOB_TITLE: 'jobTitle',
	JOB_CATEGORY_ID: 'jobCategoryID',
	JOB_CATEGORY_IDS: 'jobCategoryIDs',
};

export const AUTOCOMPLETE_SEARCH_TYPE = {
	DEPARTMENT: 'department',
	JOB_TITLE: 'jobTitle',
	JOB_CATEGORY: 'jobCategory',
	MAPPING_DEPARTMENT: 'mappingDepartment',
	MAPPING_JOB_TITLE: 'mappingJobTitle',
	TRAINING_TRACK: 'trainingTrack',
};

export const BULK_UPLOAD_HEADERS = {
	REPORT_ID: 'Report ID',
	OLD_JC: 'Old Job Category ID',
	JC: 'Job Category ID',
	EXPERIENCED: 'Experienced',
	VALIDATED: 'Validated',
	WAVE: 'Wave',
};
export const BULK_UPLOAD_MAX = 500;
export const TRAINING_TRACK_MAX = 8;

export const CLASS_SPEED_DIAL = { fab: CLASS_ANCHORED };
export const PERMISSIONS = {
	IMS_ROLE: 18,
	BRIDGES_ROLE: 1640,
	BRIDGES_PRIVILEGE: 140788,
	CT_GROUP: '114e39c6-60aa-4ae0-a06c-14d1cd994061',
};
export const BEM_NAME_ELEMENTS = {
	VIEW_BREADCRUMBS: 'navigation-breadcrumbs',
	VIEW_JOB_CATEGORY: 'job-category-editor',
	VIEW_JOB_CATEGORY_MAPPING: 'job-category-mapping-editor',
	VIEW_MENU: 'menu',
	VIEW_NAVIGATION: 'navigation',
	VIEW_RESULTS: 'results',
	VIEW_SECURITY: 'security',
	VIEW_TRAINING_TRACK: 'training-track-editor',
	VIEW_SEARCH: 'search',
	FIELD_ACCORDION: 'accordion',
	FIELD_BUTTON: 'button',
	FIELD_CHECKBOX: 'checkbox',
	FIELD_LINK: 'link',
	FIELD_LIST: 'list',
	FIELD_SELECT: 'select',
	FIELD_SPEED_DIAL: 'speed-dial',
	FIELD_SWITCH: 'switch',
	FIELD_TEXT_FIELD: 'textfield',
	SUBMIT: 'submit',
};
